import React, {useState} from 'react';
import {Button, ButtonGroup} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles'
import {EditIcon, MoveIcon} from '../../../../helpers/Icons'
import FoldersBulkEditDialog from "./FoldersBulkEditDialog";
import MoveFolderItemsDialog from "./MoveFolderItemsDialog";

const styles = {
  root: {
    display:'flex',
    flexWrap: 'wrap',
    gap: '0.5rem 1.5rem',
    fontSize: '0.85rem',
    fontWeight: 300,
    maxWidth: '960px',
    margin: '0 auto',
    border: '1px solid regba(0,0,0,0.12)',
    borderRadius: '6px',
    padding: '0.5rem',
    justifyContent: 'space-evenly'
  },
  nameText:{
    whiteSpace:'nowrap',
    overflow:'hidden',
    textOverflow:'ellipsis',
    padding:'0 0.5em',
    fontWeight:500,
    lineHeight:'1.36em',
    fontSize:'1.5rem',
  },
  field:{
    textAlign: 'center'
  },
  label: {
    fontSize:'0.7225rem',
    fontWeight: 600,
    color: 'rgba(0,0,0,0.54)',
    textTransform: 'uppercase',
    lineHeight: '1.35em',
  },
  edit:{
    display: 'flex',
    flexDirection: 'row',
    gap:'1rem 0.5rem',
    flexWrap: 'wrap',
  },
  description:{
    // flexBasis:'15em',
    // flexGrow: 1,
    // flexShrink: 1,
    // minWidth:'15em',
    // maxHeight: '4em',
    // overflow:'hidden',
  },
  descriptionText: {
    // maxHeight:'100%',
    // fontSize:'0.85em',
    // fontWeight:'300',
    // overflow: 'hidden',
    lineHeight:'1.33em',
    // display: '-webkit-box',
    // '-webkit-line-clamp': 5,
    // '-webkit-box-orient': 'vertical'
    textAlign: 'justify',
    whiteSpace: 'pre-wrap',
  },

  toolbar: {
    flexWrap:'wrap',
    margin: '1px 0 0 1px',
    '& > button':{
      margin: '-1px 0 0 -1px',
      borderColor: '#c4c4c4'
    },
    '& > button:not(:last-child)':{
      borderColor: '#c4c4c4'
    }
  },
  toolbarButton: {
    padding: '5.1px 10.2px',
    fontSize: '0.7225rem',
    height: '34px',
    '& span:first-child > span:first-child':{
      marginLeft: '-3.4px',
      marginRight: '6.8px'
    },
    '& svg':{
      width: '1em',
      height: '1em',
    }
  },
  toolbarButtonOpen: {
    padding: '5.1px 10.2px',
    color: '#267ea6',
    borderColor: '#267ea6',
    backgroundColor: '#f6f6f6',
    fontSize: '0.7225rem',
    height: '34px',
    '& span:first-child > span:first-child':{
      marginLeft: '-3.4px',
      marginRight: '6.8px'
    },
    '& svg':{
      width: '1em',
      height: '1em',
    }
  },
  datetime:{
    display:'flex',
    gap: '0.35rem',
    alignItems: 'baseline',
    '& > div':{
      whiteSpace: 'nowrap',
    },
    '& > div:first-child':{
      fontSize:'0.8rem',
    },
    '& > div:last-child':{

    },
  },
  cellSubtext:{
    fontSize:'0.85em',
    whiteSpace:'nowrap',
    fontWeight:'300',
    lineHeight: '1em'
  },
};

function FolderDetails(props) {
  const {id, folder, folderList, addFolder,
    handleMoveSelected, handleSaveFolders, mindfileUserLevel, classes } = props;

  const [editOpen, setEditOpen] = useState(false);
  const [moveOpen, setMoveOpen] = useState(false);

  const formatDateTime = (id, dateString) => {
    return (
      <div id={id} className={classes.datetime}>
        <div className={classes.date} >{dateString ? new Date(dateString).toLocaleDateString() : ''}</div>
        <div className={classes.cellSubtext} >{dateString ? new Date(dateString).toLocaleTimeString() : ''}</div>
      </div>);
  };

  const renderButton = (button, props={}) =>
    <Button variant="outlined"
            {...props}
            id={button.id}
            key={button.label}
            disabled={button.disabled}
            className={button.open ? classes.toolbarButtonOpen : classes.toolbarButton}
            onClick={button.action}
            startIcon={button.startIcon}
    >
      {button.label}
    </Button>;

  const toolbar = [
    { id: 'folderDetailsEdit',
      label: 'Edit Folder',
      startIcon: <EditIcon />,
      open: editOpen,
      action: () => setEditOpen(!editOpen)
    },
    { id: 'folderDetailsMove',
      label: 'Move All Items',
      startIcon: <MoveIcon />,
      open: moveOpen,
      action: () => setMoveOpen(!moveOpen)
    },
  ];

  const renderToolbar = () => (
    <ButtonGroup variant="outlined" className={classes.toolbar}>
      {toolbar.filter(tool => !tool.hidden).map(renderButton)}
    </ButtonGroup>);

  return <>
    <div id={id} className={classes.root}>
      <div className={classes.description}>
        <div className={classes.label}>
          Description
        </div>
        <div id="folderDetailsDescription" className={classes.descriptionText}>
          {folder.description}
        </div>
      </div>
      <div className={classes.field}>
        <div className={classes.label}>
          Items
        </div>
        <span id="folderDetailsCount">{folder.item_count}</span>
      </div>
      <div className={classes.field}>
        <div className={classes.label}>
          Created
        </div>
        {formatDateTime("folderDetailsCreated", folder.created_at)}
      </div>
      <div className={classes.field}>
        <div className= {classes.label}>
          Updated
        </div>
        {formatDateTime("folderDetailsUpdated", folder.updated_at)}
      </div>
      { mindfileUserLevel <= 2 ?
        <div>
          {renderToolbar()}
        </div>
        : null
      }
    </div>

    <FoldersBulkEditDialog
      id="editFolderDialog"
      open={editOpen}
      handleClose={setEditOpen.bind(this, false)}
      foldersMap={{[folder.id]:folder}}
      handleSaveFolders={handleSaveFolders}
    />

    <MoveFolderItemsDialog
      id="moveFolderItemsDialog"
      open={moveOpen}
      handleClose={setMoveOpen.bind(this, false)}
      foldersMap={{[folder.id]:folder}}
      folderList={folderList.filter(f => f.id !== folder.id)}
      addFolder={addFolder}
      handleMoveSelected={handleMoveSelected}
    />
  </>;
}

export default withStyles(styles)(FolderDetails);
